import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { PanelItem } from '../panels/panelItem';
import { FreeDailyBonusButtonContainer } from './freeDailyBonusButtonContainer';
import { MyChipsDisplay } from './myChipsDisplay';
import { MyJacksDisplay } from './myJacksDisplay';
export const MyCurrencyPanelItem = ({ renderSeparatePanelItems, showFreeDailyBonusButton }) => {
    const chipsElement = _jsx(MyChipsDisplay, {}, 'chips');
    const jacksElement = _jsx(MyJacksDisplay, {}, 'jacks');
    const freeDailyBonusButtonElement = showFreeDailyBonusButton && (_jsx(FreeDailyBonusButtonContainer, {}, 'free-daily-bonus'));
    const elements = [freeDailyBonusButtonElement, chipsElement, jacksElement];
    if (renderSeparatePanelItems) {
        return _jsx(_Fragment, { children: elements.map((element, i) => (element ? _jsx(PanelItem, { children: element }, i) : null)) });
    }
    return (_jsx(PanelItem, { children: _jsx("div", { children: elements }) }));
};
